<template>
  <PCSettingsBlock
    v-if="isContractsAvailable"
    :title="t('userConfiguration.contracts.title')"
  >
    <PCSettingsBlockItem :title="t('userConfiguration.contracts.sync.title')">
      <template #right>
        <f7-button
          small
          fill
          color="green"
          @click="goToSettingsSyncPage()"
        >
          {{ t('common.syncUp') }}
        </f7-button>
      </template>
    </PCSettingsBlockItem>

    <PCSettingsBlockItem :title="t('userConfiguration.contracts.lastSync.title')">
      <template #right>
        {{ lastContractsSyncDate }}
      </template>
    </PCSettingsBlockItem>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useContractsStore } from '@/js/stores/contracts';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { formatDate } from '@/js/utils/date';
import { f7 } from 'framework7-vue';
import { useI18n } from 'vue-i18n';
import { ModuleProcessMappings } from '@erpagroapp/common';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

const { t } = useI18n();

const {
  lastSyncEntities,
  lastSyncMasterData,
} = storeToRefs(useContractsStore());

const {
  availableProcessIds,
} = storeToRefs(useAppConfigStore());

const isContractsAvailable = computed(() => {
  const processId = ModuleProcessMappings.Commercialisation.Processes.PurchaseContracts.Id;
  return availableProcessIds.value.includes(processId);
});

const lastContractsSyncDate = computed(() => {
  let value = '';

  // Siempre mostraremos la menor de las sincronizaciones.
  if (lastSyncMasterData.value < lastSyncEntities.value) {
    value = formatDate(lastSyncMasterData.value.toString(), DATE_TIME_FORMAT);
  } else {
    value = formatDate(lastSyncEntities.value.toString(), DATE_TIME_FORMAT);
  }

  if (value === 'Invalid date') {
    value = '—';
  }

  return value;
});

/**
 * Navigates to the settings sync page.
 * @returns {void}
 */
function goToSettingsSyncPage() {
  f7.views.main.router.navigate('/settings/syncContracts/');
}
</script>
